"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextMultipleCell = exports.TextCell = void 0;
const react_1 = require("react");
const inline_table_field_cells_1 = require("../../../components/inline-table-field/inline-table-field-cells");
function TextCell({ collectionDatakey, ...props }) {
    const Cell = inline_table_field_cells_1.InlineTableFieldCells.useInlineTextFieldFactory({
        ...props,
        collectionDatakey,
    });
    return (0, react_1.useMemo)(() => Cell, [collectionDatakey]);
}
exports.TextCell = TextCell;
function TextMultipleCell({ collectionDatakey, ...props }) {
    const Cell = inline_table_field_cells_1.InlineTableFieldCells.useInlineTextFieldMultipleFactory({
        ...props,
        collectionDatakey,
    });
    return (0, react_1.useMemo)(() => Cell, [collectionDatakey]);
}
exports.TextMultipleCell = TextMultipleCell;
//# sourceMappingURL=text-cell.js.map